export enum ReminderDeliveryMethod {
  None = 0,
  Email = 2,
  Manual = 3,
  Mail = 4,
}

export function GetReminderDeliveryMethodIcon(method: ReminderDeliveryMethod): string {
  switch (method) {
    case ReminderDeliveryMethod.Email:
    case ReminderDeliveryMethod.Mail:
      return 'email';
    case ReminderDeliveryMethod.Manual:
      return 'print';
    case ReminderDeliveryMethod.None:
    default:
      return undefined;
  }
}

export enum TenantPageSource {
  None = 0,
  BuiltIn = 1,
  External = 2,
}

export enum AllowedOnlineTerminationSignatureKind {
  OnlyBankID = 0,
  BankIDAndClickSign = 1,
}

export enum CompanySystemSettingsBulkTarget {
  InvoiceReminder = 1,
  AutomaticAdvicing = 2,
  FaultNotification = 3,
  TenantPages = 4,
}

export interface CompanyInvoiceReminderSettings {
  enabled: boolean;
  remindAfterDays: number;
  reminderDeliveryMethodEmailWithPDF: ReminderDeliveryMethod;
  reminderDeliveryMethodEmailWithoutPDF: ReminderDeliveryMethod;
  reminderDeliveryMethodMail: ReminderDeliveryMethod;
  reminderDeliveryMethodManual: ReminderDeliveryMethod;
  reminderDeliveryMethodEInvoiceB2B: ReminderDeliveryMethod;
  reminderDeliveryMethodEInvoiceB2C: ReminderDeliveryMethod;
  reminderDeliveryMethodAvy: ReminderDeliveryMethod;
  reminderDeliveryMethodKivra: ReminderDeliveryMethod;
  reminderDeliveryMethodNoDelivery: ReminderDeliveryMethod;
  reminderDeliveryMethodSMS: ReminderDeliveryMethod;
}

export interface CompanyAutomaticAdvicingSettings {
  enabled: boolean;
  automaticAdvicingDayInMonth: number;
}

export interface CompanyFaultNotificationSettings {
  enabled: boolean;
  sendLandlordNotification: boolean;
  faultNotificationReceivers: string[];
}

export interface CompanyTenantPagesSettings {
  enabled: boolean;
  tenantPageSource: TenantPageSource;
  tenantPageExternalUrl: string;
  invoiceRegistrationMessage: string;
  invoiceRegistrationMessageRow2: string;
  invoiceHasAccountMessage: string;
  invoiceHasAccountMessageRow2: string;
  allowPrintTerminationFormDwelling: boolean;
  allowPrintTerminationFormOther: boolean;
  allowPrintTerminationFormParking: boolean;
  allowPrintTerminationFormPremises: boolean;
  allowTerminationOnlineDwelling: boolean;
  allowTerminationOnlineOther: boolean;
  allowTerminationOnlineParking: boolean;
  allowTerminationOnlinePremises: boolean;
  allowedOnlineTerminationSignature: AllowedOnlineTerminationSignatureKind;
  displayDwellingInspection: boolean;
  onlineTerminlationCallbackEmailAddresses: string;
}

export interface CompanyTerminationSettings {
  useDigitalSigningWhenTerminatedByTenant: boolean;
  useDigitalSigningWhenTerminatedByLandlord: boolean;
  requireSignatureBeforeTerminationWhenLandlordUsesDigitalSigning: boolean;
  landlordMessage: string;
}

export interface CompanyRentSettings {
  roundPeriodRent: boolean;
}

export interface CompanyExternalAccountsReceivableSettings {
  enabled: boolean;
}

export interface CompanySystemSettings {
  invoiceReminder: CompanyInvoiceReminderSettings;
  automaticAdvicing: CompanyAutomaticAdvicingSettings;
  faultNotification: CompanyFaultNotificationSettings;
  tenantPages: CompanyTenantPagesSettings;
  termination: CompanyTerminationSettings;
  rent: CompanyRentSettings;
  externalAccountsReceivable: CompanyExternalAccountsReceivableSettings;
}

export interface CompanySystemSettingsBulkUpdate {
  companyIds: string[];
  excludedCompanyIds?: string[];
  filter?: any;
  target: CompanySystemSettingsBulkTarget;
  settings: CompanySystemSettings;
}

export interface CompanySystemSettingsBulkTemplate {
  companyIds?: string[];
  excludedCompanyIds?: string[];
  filter?: any;
}
